import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/Buttons/Button.tsx';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { ButtonWithLoader } from 'common/components/Buttons/ButtonWithLoader.tsx';
import { provisioningQueries } from '../utils/queries.ts';
import { useIsMutating } from '@tanstack/react-query';

type UploadDialogProps = {
  open: boolean;
  fileName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const BoxStyled = styled(Box)(({ theme }) => ({
  '.MuiButtonBase-root': {
    width: theme.spacing(80),
  },
}));

export const UploadDialog = ({ open, fileName, onConfirm, onCancel }: UploadDialogProps) => {
  const { t } = useTranslation();
  const isMutating = useIsMutating({ mutationKey: provisioningQueries.upload });

  return (
    <Dialog open={open} fullWidth maxWidth={'xs'}>
      <DialogTitle variant="h2">{t('bulkProvisioning.title')}</DialogTitle>
      <DialogContent>
        <Typography variant="text1">{t('bulkProvisioning.fileUploadingInfo')}</Typography>
        <Typography
          variant="text1"
          component="div"
          sx={{ overflowWrap: 'anywhere', fontWeight: 700 }}
        >
          {fileName}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={!!isMutating} onClick={onCancel} variant="tertiary">
          {t('common.cancel')}
        </Button>
        <BoxStyled>
          <ButtonWithLoader
            onClick={onConfirm}
            variant="primary"
            isLoading={!!isMutating}
            disabled={!!isMutating}
          >
            {t('common.confirm')}
          </ButtonWithLoader>
        </BoxStyled>
      </DialogActions>
    </Dialog>
  );
};
